import React, { PropsWithChildren, useEffect } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import useDiagnosticCollection, { DiagnosticCollectorProps } from './CollectionTool/useDiagnosticCollection';
import SessionStorage from '../../utils/SessionStorage';
import { isIOS } from '../../utils/cob-utils';
import useSkipPADiagnosticCollection from './SkipPADiagnosticCollection/useSkipPADiagnosticCollection';

export interface IDiagnosticInformationCollectorProps extends MappedComponentProperties, DiagnosticCollectorProps {}

export const DiagnosticInformationCollectorEditConfig = {
    emptyLabel: 'Diagnostic Information Collector',
    isEmpty: (props: PropsWithChildren<IDiagnosticInformationCollectorProps>) => {
        return !props || !props.loggingLevel;
    }
};


const DiagnosticInformationCollector = (props: PropsWithChildren<IDiagnosticInformationCollectorProps>): JSX.Element => {
    useDiagnosticCollection(props);
    useSkipPADiagnosticCollection(props);

    if ( !props.isInEditor ) {
        return null;
    }

    return (
        <div style={{
            textAlign: 'center',
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
        }}>
            <h3 style={{
                marginTop: '1rem',
            }}>Diagnostic Information Collector</h3>
            <p>This is not visible outside of the AEM Editor<br/></p>
            <div>
                <h5>Logging Level: {props.loggingLevel ?? 'disabled'}</h5>
            </div>
        </div>
    )
};

export default DiagnosticInformationCollector;
